if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        loadMoreBtn: "[data-load-more]",
        loadMoreBtnWrapper: ".m-featured-collection__button",
        productsContainer: "[data-products-container]",
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        availableNumber: ["[data-available-number]"],
        countDown: "[data-flashsale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.buttonType = this.dataset.buttonType;
      this.infiniteLoad = this.dataset.infiniteLoad;
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableFlashsale = this.dataset.enableFlashsale === "true";
      this.enableCountdown = this.dataset.enableCountdown === "true";
      this.id = this.dataset.id;
      this.items = this.dataset.items;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.updateScrollbar = this.updateScrollbar.bind(this);
      this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
      this.onScrollbarKeyDown = this.onScrollbarKeyDown.bind(this);

      this.initByScreenSize();
      this.initScrollbar();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
        this.initScrollbar();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
        this.initScrollbar();
      });

      if (this.enableFlashsale) this.initFlashSale();

      this.canLoad = true;
      this.currentPage = 1;
      this.spinner = spinner();

      if (!this.enableSlider && this.buttonType === "load" && this.infiniteLoad === "true") {
        this.initInfiniteLoad();
      }
      if (!this.enableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }
      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileDisableSlider &&
        this.buttonType === "load" &&
        this.infiniteLoad === "true"
      ) {
        this.initInfiniteLoad();
      }
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }

      document.addEventListener("matchMobile", () => {
        if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
          this.initLoadMore();
        }
        if (
          MinimogTheme.config.mqlMobile &&
          this.mobileDisableSlider &&
          this.buttonType === "load" &&
          this.infiniteLoad === "true"
        ) {
          this.initInfiniteLoad();
        }
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.slider && !this.slider.destroyed) {
          this.slider.destroy(false, true);
        }
        this.slider = null;
        this.swiper = null;
        this.scrollbarSwiper = null;
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      if (this.slider && !this.slider.destroyed) {
        this.slider.destroy(false, true);
        this.scrollbarSwiper = null;
      }

      slideContainer && slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: false,
        initialSlide: 0,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1024: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              // Calculate controls position
              const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton && prevButton.classList.remove("m:hidden");
                nextButton && nextButton.classList.remove("m:hidden");
              }
              this.updateScrollbar();
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer && slideContainer.swiper;
      this.bindScrollbarToSlider();
    }

    getScrollbarScroller() {
      return this.querySelector(".m-product-list");
    }

    initScrollbar() {
      this.scrollbarEl = this.querySelector("[data-collection-scrollbar]");
      this.scrollbarThumb = this.querySelector("[data-collection-scrollbar-thumb]");
      if (!this.scrollbarEl || !this.scrollbarThumb) return;

      if (!this.scrollbarBound) {
        this.scrollbarBound = true;
        this.scrollbarEl.addEventListener("pointerdown", this.onScrollbarPointerDown);
        this.scrollbarEl.addEventListener("keydown", this.onScrollbarKeyDown);
        window.addEventListener("resize", this.updateScrollbar);
      }

      const scroller = this.getScrollbarScroller();
      if (scroller && this.scrollbarScroller !== scroller) {
        if (this.scrollbarScroller) {
          this.scrollbarScroller.removeEventListener("scroll", this.updateScrollbar);
        }
        this.scrollbarScroller = scroller;
        scroller.addEventListener("scroll", this.updateScrollbar, { passive: true });
      }

      this.bindScrollbarToSlider();
      requestAnimationFrame(() => this.updateScrollbar());
    }

    bindScrollbarToSlider() {
      if (!this.slider || typeof this.slider.on !== "function") return;
      if (this.scrollbarSwiper === this.slider) return;

      this.scrollbarSwiper = this.slider;
      this.slider.on("init", this.updateScrollbar);
      this.slider.on("resize", this.updateScrollbar);
      this.slider.on("setTranslate", this.updateScrollbar);
      this.slider.on("slideChange", this.updateScrollbar);
      this.slider.on("slideChangeTransitionEnd", this.updateScrollbar);
      this.slider.on("touchStart", () => {
        this.scrollbarEl && this.scrollbarEl.classList.add("is-dragging");
      });
      this.slider.on("touchEnd", () => {
        this.scrollbarEl && this.scrollbarEl.classList.remove("is-dragging");
      });
    }

    isSliderActive() {
      return Boolean(this.slider && !this.slider.destroyed);
    }

    getSliderScrollRatio(swiper) {
      const minT = swiper.minTranslate();
      const maxT = swiper.maxTranslate();
      const span = maxT - minT;
      if (!span) return 0;
      return Math.min(1, Math.max(0, (swiper.translate - minT) / span));
    }

    getScrollbarRatio() {
      let sizeRatio = 1;
      let ratio = 0;

      if (this.isSliderActive()) {
        const swiper = this.slider;
        const slides = Array.from(swiper.slides || []);
        const realCount = Math.max(slides.length, 1);
        const perView = Number(swiper.params.slidesPerView) || 1;

        if (swiper.virtualSize && swiper.width) {
          sizeRatio = Math.min(1, swiper.width / swiper.virtualSize);
        } else {
          sizeRatio = Math.min(1, perView / realCount);
        }

        ratio = this.getSliderScrollRatio(swiper);
      } else {
        const scroller = this.getScrollbarScroller();
        if (!scroller) return { sizeRatio: 1, ratio: 0 };
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        sizeRatio = scroller.scrollWidth > 0 ? Math.min(1, scroller.clientWidth / scroller.scrollWidth) : 1;
        ratio = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      }

      return { sizeRatio, ratio };
    }

    updateScrollbar() {
      if (!this.scrollbarEl || !this.scrollbarThumb) return;

      const { sizeRatio, ratio } = this.getScrollbarRatio();
      const noOverflow = sizeRatio >= 0.999;

      this.scrollbarEl.classList.toggle("is-disabled", noOverflow);
      this.scrollbarEl.setAttribute("aria-valuenow", String(Math.round(ratio * 100)));
      if (noOverflow) return;

      const trackWidth = this.scrollbarEl.clientWidth;
      const thumbWidth = Math.max(trackWidth * sizeRatio, 48);
      const maxOffset = Math.max(trackWidth - thumbWidth, 0);

      this.scrollbarThumb.style.width = `${thumbWidth}px`;
      this.scrollbarThumb.style.transform = `translateX(${ratio * maxOffset}px)`;
    }

    scrollToRatio(ratio) {
      ratio = Math.min(1, Math.max(0, ratio));

      if (this.isSliderActive()) {
        const swiper = this.slider;
        const minT = swiper.minTranslate();
        const maxT = swiper.maxTranslate();
        const translate = minT + ratio * (maxT - minT);
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateProgress(translate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        return;
      }

      const scroller = this.getScrollbarScroller();
      if (!scroller) return;
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll > 0) scroller.scrollLeft = maxScroll * ratio;
    }

    getScrollbarRatioFromEvent(event) {
      const rect = this.scrollbarEl.getBoundingClientRect();
      const thumbWidth = this.scrollbarThumb.offsetWidth;
      const max = rect.width - thumbWidth;
      const x = event.clientX - rect.left - thumbWidth / 2;
      return max > 0 ? Math.min(1, Math.max(0, x / max)) : 0;
    }

    moveScrollbarToEvent(event) {
      if (!this.scrollbarDragStart) return;

      const deltaX = event.clientX - this.scrollbarDragStart.x;
      const trackWidth = this.scrollbarEl.clientWidth;
      if (!trackWidth) return;

      if (this.isSliderActive()) {
        const swiper = this.slider;
        const minT = swiper.minTranslate();
        const maxT = swiper.maxTranslate();
        const span = maxT - minT;
        const translate = Math.max(
          maxT,
          Math.min(minT, this.scrollbarDragStart.translate - deltaX * (span / trackWidth))
        );

        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateProgress(translate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        return;
      }

      const scroller = this.getScrollbarScroller();
      if (!scroller) return;
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 0) return;

      scroller.scrollLeft = Math.max(
        0,
        Math.min(maxScroll, this.scrollbarDragStart.scrollLeft - deltaX * (maxScroll / trackWidth))
      );
    }

    onScrollbarPointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      event.preventDefault();
      this.scrollbarEl.classList.add("is-dragging");
      this.scrollbarEl.setPointerCapture(event.pointerId);

      const ratio = this.getScrollbarRatioFromEvent(event);
      this.scrollToRatio(ratio);

      this.scrollbarDragStart = {
        x: event.clientX,
        translate: this.isSliderActive() ? this.slider.translate : 0,
        scrollLeft: this.getScrollbarScroller()?.scrollLeft ?? 0,
      };

      const onMove = (e) => this.moveScrollbarToEvent(e);
      const onUp = () => {
        this.scrollbarDragStart = null;
        this.scrollbarEl.classList.remove("is-dragging");
        this.scrollbarEl.removeEventListener("pointermove", onMove);
        this.scrollbarEl.removeEventListener("pointerup", onUp);
        this.scrollbarEl.removeEventListener("pointercancel", onUp);
        this.updateScrollbar();
      };

      this.scrollbarEl.addEventListener("pointermove", onMove);
      this.scrollbarEl.addEventListener("pointerup", onUp);
      this.scrollbarEl.addEventListener("pointercancel", onUp);
    }

    onScrollbarKeyDown(event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      const { ratio } = this.getScrollbarRatio();
      const delta = event.key === "ArrowRight" ? 0.1 : -0.1;
      this.scrollToRatio(ratio + delta);
    }

    initLoadMore() {
      this.triggerLoad = false;
      this.totalPages = parseInt(this.dataset.totalPages);

      addEventDelegate({
        context: this.container,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore();
        },
      });
    }

    initInfiniteLoad() {
      const maxPages = this.dataset.maxPages;

      window.addEventListener("scroll", (e) => {
        this.canLoad = this.currentPage < parseInt(maxPages);

        if (!this.canLoad) return;
        if (this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY && !this.triggerLoad) {
          this.triggerLoad = true;
          this.handleLoadMore();
        }
      });
    }

    async handleLoadMore() {
      this.currentPage++;
      this.canLoad = this.currentPage < this.totalPages;
      this.toggleLoading(true);
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);

      const url = this.dataset.url;
      const dataUrl = `${url}?page=${this.currentPage}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        this.toggleLoading(false);
        const dom = generateDomFromString(html);
        const products = dom.querySelector(this.selectors.productsContainer);
        const oldCards = this.domNodes.productsContainer.childElementCount;
        let isAppended = false;

        if (products) {
          Array.from(products.childNodes).forEach((product) => {
            this.domNodes.productsContainer.appendChild(product);
            const check = setInterval(() => {
              if (this.domNodes.productsContainer.childElementCount > oldCards) {
                clearInterval(check);
                isAppended = true;
              }
            }, 50);
          });
        }

        if (this.enableFlashsale && res.ok && res.payload && res.payload.length) {
          const { expires_date } = res.payload[0];
          this.expires_date = expires_date;
          const check = setInterval(() => {
            if (isAppended) {
              clearInterval(check);
              const cards = this.domNodes.productsContainer.querySelectorAll(".m-product-card");
              cards.forEach((card) => {
                const content = card.querySelector(".m-product-card__content");
                const progress = card.querySelector(".m-product-sale-progress");
                if (!progress) {
                  let soldNumber;
                  if (card.dataset.soldNumber) {
                    soldNumber = card.dataset.soldNumber;
                  }
                  const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
                  const newComponent = generateDomFromString(component);
                  content.appendChild(newComponent);
                }
              });
            }
          }, 50);
        }

        this.triggerLoad = false;

        if (!this.canLoad) {
          this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("m:hidden");
        }
      });
    }

    toggleLoading(status) {
      if (!this.domNodes.loadMoreBtn) return;
      if (status) {
        this.domNodes.loadMoreBtn.classList.add("m-spinner-loading");
      } else {
        this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading");
      }
    }

    async initFlashSale() {
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);
      if (res.ok && res.payload && res.payload.length) {
        const { expires_date } = res.payload[0];
        this.expires_date = expires_date;
        this.domNodes.products.forEach((card) => {
          const content = card.querySelector(".m-product-card__content");
          const pcardSale = card.querySelector(".m-product-sale-progress");
          let soldNumber;
          if (card.dataset.soldNumber) {
            soldNumber = card.dataset.soldNumber;
          }
          const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
          const newComponent = generateDomFromString(component);
          if (!pcardSale) {
            content.appendChild(newComponent);
          }
        });
        this.initCountDown();
      }
    }

    initCountDown() {
      const endTime = new Date(this.expires_date).getTime();
      this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), endTime, {
        loop: true,
      });
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}
